import { z } from "zod"

export const DefaultSessionSchema = z.object({
    accessToken: z.string(),
    affiliateCode: z.string().optional(),
    affiliateQueryParams: z.object().optional(),
})
